import * as React from "react"

import { cn } from "@/lib/utils"

// STANDARD 2.16: text-field replaces both legacy text tiers (rather than text-body).
const inputSizes = {
  md: "h-control bg-raised border-control-edge rounded-control px-2.5 text-field md:text-field placeholder:text-ink-muted",
} as const

function Input({ className, type, size, ...props }: Omit<React.ComponentProps<"input">, "size"> & { size?: "md" }) {
  return (
    <input
      type={type}
      data-slot="input"
      data-size={size}
      className={cn(
        "file:text-ink placeholder:text-ink-muted selection:bg-primary selection:text-primary-foreground border-edge bg-raised text-ink flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        size ? inputSizes[size] : undefined,
        className
      )}
      {...props}
    />
  )
}

export { Input }
